import React, { Component } from "react";
import Confetti from "react-confetti";

import {
  Wrapper,
  Modal,
  CardBody,
  InternalImage,
  ExternalImage
} from "app/NativeComponents/common";

import BadgeTitle from "./BadgeTitle";
import BadgeCopy from "./BadgeCopy";

class BadgeModal extends Component {
  renderConfetti() {
    let colors = [
      "rgba(166,124,0, 0.5)",
      "rgba(191,155,48, 0.5)",
      "rgba(255,191,0, 0.5)",
      "rgba(255,207,64, 0.5)",
      "rgba(255,220,115, 0.5)"
    ];

    let width = window.innerWidth;
    let height = window.innerHeight;

    if (this.props.badge.gold_badge == 1) {
      return (
        <Confetti
          style={{ zIndex: -1 }}
          width={width}
          height={height}
          colors={colors}
          numberOfPieces={1000}
          wind={0.014}
        />
      );
    }
    return <Wrapper />;
  }

  render() {
    return (
      <Modal>
        {this.renderConfetti()}
        <CardBody style={{ alignItems: "center" }}>
          <InternalImage
            style={{ width: 300 }}
            contain
            image={"/assets/images/dm_white_logo_medium.png"}
          />
          <BadgeTitle {...this.props} />
          <ExternalImage
            style={{
              width: 200,
              height: 200,
              borderRadius: 200,
              margin: 15,
              backgroundColor: "#FFF"
            }}
            image={this.props.badge.image}
          />
          <BadgeCopy {...this.props} />
        </CardBody>
      </Modal>
    );
  }
}

export default BadgeModal;
